import { render, staticRenderFns } from "./OrgHomeMarketingSources.vue?vue&type=template&id=3b8c6007&scoped=true&"
import script from "./OrgHomeMarketingSources.vue?vue&type=script&lang=js&"
export * from "./OrgHomeMarketingSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c6007",
  null
  
)

export default component.exports